module.exports = __webpack_public_path__ + "img/index-banner1-m.536c5e47.jpg";